import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  useEffect(() => {
    // Initialize smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Add custom cursor effect
    const cursor = document.createElement('div');
    cursor.className = 'custom-cursor';
    document.body.appendChild(cursor);

    const updateCursor = (e) => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    };

    const addCursorEffect = () => {
      cursor.style.transform = 'scale(1.5)';
      cursor.style.backgroundColor = 'rgba(99, 102, 241, 0.3)';
    };

    const removeCursorEffect = () => {
      cursor.style.transform = 'scale(1)';
      cursor.style.backgroundColor = 'rgba(99, 102, 241, 0.1)';
    };

    document.addEventListener('mousemove', updateCursor);
    
    // Add cursor effects to interactive elements
    const interactiveElements = document.querySelectorAll('a, button, .cursor-hover');
    interactiveElements.forEach(el => {
      el.addEventListener('mouseenter', addCursorEffect);
      el.addEventListener('mouseleave', removeCursorEffect);
    });

    // Add loading animation class removal
    setTimeout(() => {
      document.body.classList.add('loaded');
    }, 500);

    // Cleanup
    return () => {
      document.removeEventListener('mousemove', updateCursor);
      interactiveElements.forEach(el => {
        el.removeEventListener('mouseenter', addCursorEffect);
        el.removeEventListener('mouseleave', removeCursorEffect);
      });
      if (cursor.parentNode) {
        cursor.parentNode.removeChild(cursor);
      }
    };
  }, []);

  const pageVariants = {
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.6, -0.05, 0.01, 0.99],
        staggerChildren: 0.1
      }
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.4,
        ease: [0.6, -0.05, 0.01, 0.99]
      }
    }
  };

  return (
    <div className="app-layout">
      <Header />
      
      <AnimatePresence mode="wait">
        <motion.main
          className="main-content"
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          {children}
        </motion.main>
      </AnimatePresence>
      
      <Footer />
      
      {/* Loading overlay */}
      <div className="loading-overlay">
        <div className="loading-content">
          <div className="loading-logo">
            <span className="gradient-text">A</span>
          </div>
          <div className="loading-text">
            <span>Loading amazing things...</span>
          </div>
          <div className="loading-progress">
            <div className="progress-bar"></div>
          </div>
        </div>
      </div>

      {/* Scroll progress indicator */}
      <div className="scroll-progress">
        <div className="scroll-progress-bar"></div>
      </div>
    </div>
  );
};

export default Layout;